let uploadedFiles = [];
let uploadedFiles2 = [];
let post_list = '';
let inchToPx = 300;
let cmToPx = 120;
var picker;

$(document).ready(function() { 
	$("body").on('change', '#step-2-confirmation input[type="checkbox"]', function(e){
		var checked = $(this).prop('checked');
		if(checked == true) {
			$("#go-to-step-3").show();
		} else {	
			$("#go-to-step-3").hide();
		}   
    });
  
	$(".mango-uploader-wrapper #go-to-step-3").click(function(){
		$("#mango-uploader-step-1").hide();            
      	$("#mango-uploader-step-2").hide();     
		$("#mango-uploader-step-3").show();   
     	$("#step-2-confirmation input").prop('checked', false);   
		$("#go-to-step-3").hide();      
      
        $('.owl-carousel').slick({
          dots: false,
          arrows: true,
          fade: true,        
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,        
        });      
        $('.owl-carousel').on('afterChange', function(event, slick, currentSlide){
			$('.slider-custom-counter-current').text(currentSlide+1);
        });
    });
  
	$("body").on('change', '#step-3-confirmation input[type="checkbox"]', function(e){
		var checked = $(this).prop('checked');
		if(checked == true) {
			$("#go-to-finish").show();
		} else {	
			$("#go-to-finish").hide();
		}   
    });  
  	$(".mango-uploader-wrapper #go-to-finish").click(function(){
		finishUploader();
    });  
    $("body").on('click', ".mango-uploader-wrapper2 button.close", function(e){
		closeUploader();    
    });
    $("body").on('click', ".mango-uploader-wrapper2 button.close2", function(e){
		closePreview();    
    });  
    $("body").on('click', ".mango-uploader-wrapper2 #step-2-cancel", function(e){
		closeUploader();
    });  
    $("body").on('click', ".mango-uploader-wrapper2 #step-3-cancel", function(e){
		closeUploader();
    });    
    $("body").on('click', ".mango-uploader-wrapper2 #step-4-cancel", function(e){
		closePreview();
    });  

  
    $("body").on('click', ".mango-uploader-wrapper button.close", function(e){
		closeUploader();    
    });
    $("body").on('click', ".mango-uploader-wrapper button.close2", function(e){
		closePreview();    
    });  
    $("body").on('click', ".mango-uploader-wrapper #step-2-cancel", function(e){
		closeUploader();
    });  
    $("body").on('click', ".mango-uploader-wrapper #step-3-cancel", function(e){
		closeUploader();
    });    
    $("body").on('click', ".mango-uploader-wrapper #step-4-cancel", function(e){
		closePreview();
    });

    $(".mango-uploader-wrapper #btn-remove-files").click(function(){
		$("#file-upload-show-spreads-btn").hide();           
		$("#file-upload-show-btn").show();    
		closePreview();         
		$( "#mango-uploader-files" ).val('');
		$( "#mango-uploader-files-names" ).val('');     
        $('.owl-carousel2').slick('unslick');     
        $( "#mango-uploader-preview-slider2 .item" ).remove();    
        $("#message-no-uploader-files").show();        
    });



    $("#file-upload-show-btn").click(function(){
        $( "#mango-uploader-preview-order .item" ).remove();        
        $( "#mango-uploader-preview-slider .item" ).remove();  
        $( "#mango-uploader-preview-slider2 .item" ).remove();        
      
      
        var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
		var albumSpreadWidthPx = parseInt(parseFloat($("#mango_upload_file_width").val()) * inchToPx * 2);       
        var albumSpreadHeightPx = parseInt(parseFloat($("#mango_upload_file_height").val()) * inchToPx);              
        $(".label-album-spreads").text(albumSpreads);
        $(".label-album-size").text(albumSpreadWidthPx + 'x' + albumSpreadHeightPx);      
        $(".slider-custom-counter-qty").text(albumSpreads);       
		$(".slider-custom-counter-qty2").text(albumSpreads);         
      
		const filestack_client = filestack.init('AbkDGv2FYSHi0mxqhYMgQz'); 
        const options = {
        	displayMode: 'inline',
        	container: '#droppane',    
  			accept: ["image/jpeg", "image/jpg"],          
			fromSources: ["local_file_system","googledrive","onedrive"],
			exposeOriginalFile: true,          
          	maxFiles: albumSpreads,
          	minFiles: albumSpreads,          
            transformations: {
            	crop: false,
           		circle: false,
           	 	rotate: false
            },
			customText: {                     
        		'Our file upload limit is {maxFiles} {filesText}': 'You selected the wrong number of files. The number of files must be equal to the number of spreads selected.'
            },
            onFileUploadFinished: function(file) {
//		console.log(file);              
				uploadedFiles.push(file["url"]);
				uploadedFiles2.push(file["filename"] +'^'+file["handle"]);          
            },          
       	 	onUploadDone: function(){
              	uploadedFiles2.sort();
   				uploadFinished(uploadedFiles2);
              	// send tokens to helper
              	$.each( uploadedFiles2, function( key, value ) {
					post_list = post_list + value +',';
				});
              	var post_list_data = { 
                  	hash : $( "#mango_post_list_data_hash" ).val(),
                    files : post_list,
                  	source : 'qtalbumseu'
                };
                $.ajax({
					type: "POST",
					url: "https://filestack.qtalbums.ovh/token_to_db.php",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded'},                  
					data: post_list_data,
					success: function(msg){
					console.log(msg);  
                 }
				});      
              	// end sending
  			},      
          	onFileSelected: checkImgSize,  
          	onClose: function(){
            },      
            uploadConfig: {
				tags: {
					"foo": "bar"
				},

			},   
        };
      	picker = filestack_client.picker(options);
      
		$(".mango-uploader-wrapper").show();
		$("#mango-uploader-modal").show();
      	$("#mango-uploader-step-1").show();
		$("#mango-uploader-step-2").hide(); 
		$("#mango-uploader-step-3").hide();               
		picker.open();  
		window.scrollTo(0, 0);         
    });
  
    $("#file-upload-show-spreads-btn").click(function(){ 
		$(".mango-uploader-wrapper2").show();
		$("#mango-uploader-modal2").show();
		$("#mango-uploader-step-4").show();     
      if(  !$('.owl-carousel2').hasClass("slick-initialized")  ) {
          $('.owl-carousel2').slick({
            dots: false,
            arrows: true,
            fade: true,        
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          });        
      
          $('.owl-carousel2').on('afterChange', function(event, slick, currentSlide){
              $('.slider-custom-counter-current2').text(currentSlide+1);
          });             
      }
    });
  
  
  

    function closeUploader(){
		$(".mango-uploader-wrapper").hide();
		$("#mango-uploader-modal").hide();
		$("#mango-uploader-step-1").hide();            
      	$("#mango-uploader-step-2").hide();     
		$("#mango-uploader-step-3").hide();       
        $("#mango-uploader-files").val('');
		$("#mango-uploader-files-names").val('');        
      	picker.close();      
 uploadedFiles = [];
 uploadedFiles2 = [];       
		$('.owl-carousel').slick('unslick');
        $('.slider-custom-counter-current2').text("1");      
        $( "#mango-uploader-preview-order .item" ).remove();        
        $( "#mango-uploader-preview-slider .item" ).remove();  
        $( "#mango-uploader-preview-slider2 .item" ).remove();        
    }
    function closePreview(){
		$(".mango-uploader-wrapper2").hide();
		$("#mango-uploader-modal2").hide();
		$("#mango-uploader-step-4").hide();
    }  
    function finishUploader(){
		$(".mango-uploader-wrapper").hide();
		$("#mango-uploader-modal").hide();
		$("#mango-uploader-step-1").hide();            
      	$("#mango-uploader-step-2").hide();     
		$("#mango-uploader-step-3").hide();         
		$("#file-upload-show-btn").hide();    
		$("#file-upload-show-spreads-btn").show();        
      	picker.close();
 uploadedFiles = [];
 uploadedFiles2 = [];   
      	$('.owl-carousel').slick('unslick');      
        $('.slider-custom-counter-current2').text("1");      
      	$( "#mango-uploader-preview-order .item" ).remove();        
        $( "#mango-uploader-preview-slider .item" ).remove();       

     	$("#step-3-confirmation input").prop('checked', false);   
		$("#go-to-finish").hide();       
        $("#message-no-uploader-files").hide();         
    }
  
    function uploadFinished(upfiles){
//		  console.log(upfiles);
		$("#mango-uploader-step-1").hide();            
      	$("#mango-uploader-step-2").show();     
		$("#mango-uploader-step-3").hide();                 
        var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
      	//if(upfiles.lenght > 0) {
			$.each( upfiles, function( key, value ) {
				var temp_array = value.split('^');
              	var filename = temp_array[0];              
              	var handle = temp_array[1];            
              	$( "#mango-uploader-preview-order" ).append( '<div class="item"><img src="https://cdn.filestackcontent.com/resize=width:600/' + handle + '" alt="" style="width:100%;" /><span> '+ (key+1)+' of '+albumSpreads+'</span></div>');	              
              	$( "#mango-uploader-preview-slider" ).append( '<div class="item"><img src="https://cdn.filestackcontent.com/resize=width:1800/' + handle + '" alt="" style="width:100%;" /></div>');              
				$( "#mango-uploader-preview-slider2" ).append( '<div class="item"><img src="https://cdn.filestackcontent.com/resize=width:1800/' + handle + '" alt="" style="width:100%;" /></div>');              		
              	$( "#mango-uploader-files" ).val( $( "#mango-uploader-files" ).val() +  handle + ';' );
              	$( "#mango-uploader-files-names" ).val( $( "#mango-uploader-files-names" ).val() +  filename + ';' );              
			});
     if(albumSpreads > upfiles.length) { 
		alert("There was an error while uploading. Not all files have been loaded. Please add the files again.");      
     } 
      	//}    
    }
  
    function checkImgSize(thisfile) {
        var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
		var albumSpreadWidthPx = parseInt($("#mango_upload_file_width").val()) * inchToPx * 2;       
        var albumSpreadHeightPx = parseInt($("#mango_upload_file_height").val()) * inchToPx;          

        return new Promise(function (resolve, reject) {
          const minWidth = albumSpreadWidthPx * 0.96;
          const minHeight = albumSpreadHeightPx * 0.96;
          const blob = thisfile.originalFile;
          const url = window.URL.createObjectURL(blob);
          const img = new Image();
          img.src = url;

          img.onload = function () {
            window.URL.revokeObjectURL(url);
            //alert( this.naturalWidth +'---'+this.naturalHeight);
            if (this.naturalWidth < minWidth) {
              reject('Image quality ('+thisfile.filename+') is to poor. Minimal image dimentions are ' + minWidth + 'x' + minHeight + 'px');
              picker.cancel();    
            }
            else if (this.naturalHeight < minHeight) {
              reject('Image quality ('+thisfile.filename+') is to poor. Minimal image dimentions are  ' + minWidth + 'x' + minHeight + 'px');
            }
            var ratio_natural = this.naturalWidth / this.naturalHeight;
            var ratio_min = ((minWidth/minHeight) - 0.1);
            var ratio_max = ((minWidth/minHeight) + 0.1);            
            if ( (ratio_natural.toFixed(2) < ratio_min.toFixed(2)) || (ratio_natural.toFixed(2) > ratio_max.toFixed(2)) ) {
              reject('WRONG DESIGN DIMENSIONS. You have uploaded '+this.naturalWidth+'x'+this.naturalHeight+'px while we need '+minWidth+'x'+minHeight+'px or bigger');
            }
            resolve();
          }
        });
    }
});
